export const farms = {
  _root: "/farms",
  farm: {
    _root: "/:farmID"
  }
};
